import React from 'react';

import addressIcon from './icons/glyphicons-map-marker.png';
import callIcon from './icons/glyphicons-earphone.png';
import emailIcon from './icons/glyphicons-envelope.png';

class GetInTouch extends React.Component {
    render() {
        return (
            <div>
                <h3>Get in Touch</h3>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://maps.google.com/maps?q=530+wickham+rd+manhattan+ks"
                    className="flex"
                >
                    <div css={{ width: 30 }}>
                        <img
                            src={addressIcon}
                            className="invert"
                            css={{ color: 'white', width: 10 }}
                            alt="Address"
                        />
                    </div>
                    <address>
                        <p className="my0">
                            530 wickham rd.<br />
                            manhattan, ks<br />
                            66502
                        </p>
                    </address>
                </a>

                <a
                    href="mailto:alanhoneyphoto@gmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-baseline"
                >
                    <div css={{ width: 30 }}>
                        <img
                            src={emailIcon}
                            className="invert"
                            css={{ color: 'white', width: 12 }}
                            alt="Email"
                        />
                    </div>
                    <p className="my0">alanhoneyphoto@gmail.com</p>
                </a>
                <a href="tel:+17855372210" className="flex items-baseline">
                    <div css={{ width: 30 }}>
                        <img
                            src={callIcon}
                            className="invert"
                            css={{ color: 'white', width: 12 }}
                            alt="Call"
                        />
                    </div>

                    <p className="my0">785.537.2210</p>
                </a>
            </div>
        );
    }
}

export default GetInTouch;



// WEBPACK FOOTER //
// ./src/core/components/GetInTouch/index.js